import { supabase } from "../../supabaseClient";


export async function fetchAdminAuditEvents({
  area = null,
  limit = 300,
  offset = 0,
} = {}) {
  const {
    data,
    error,
  } =
    await supabase.rpc(
      "admin_get_audit_events",
      {
        p_area:
          area &&
          area !== "all"
            ? area
            : null,

        p_limit:
          Math.max(
            1,
            Math.min(
              Number(limit) ||
                300,
              1000
            )
          ),

        p_offset:
          Math.max(
            0,
            Number(offset) ||
              0
          ),
      }
    );


  if (error) {
    throw error;
  }


  return Array.isArray(
    data
  )
    ? data
    : [];
}